import React from 'react';
import { HiOutlineExclamation } from 'react-icons/hi';
import {
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalFooter,
  Center,
  Icon,
} from '@chakra-ui/react';
import { Loading } from 'components';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  loading: boolean;
  error: boolean;
  data?: SupportContact;
}

export const ContactModal = ({
  isOpen,
  onClose,
  data,
  loading,
  error,
}: ContactModalProps) => {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minW={{ base: '80%', md: '548px' }}
        py="24px"
        px="18px"
        bg="white"
      >
        {error ? (
          <Center flexDir="column">
            <Icon
              borderRadius="100px"
              padding="16px"
              bg="grey.200"
              w="80px"
              h="80px"
              as={HiOutlineExclamation}
              color="grey.600"
            />
            <Text fontWeight="medium" color="text.100" fontSize="20px">
              Algo deu errado
            </Text>
            <Text color="text.300" fontSize="16px">
              Recarregue e tente novamente
            </Text>
          </Center>
        ) : !data && loading ? (
          <Center h="200px">
            <Loading />
          </Center>
        ) : (
          <>
            <Text fontWeight={800} color="black" alignSelf="start">
              Entre em contato
            </Text>
            <Text fontSize="14px" mt="8px" textColor="text.200">
              Caso prefira, por favor entre em contato conosco através das
              opções disponíveis abaixo
            </Text>
            <Text mt="24px" fontWeight={800} color="black" alignSelf="start">
              {data?.name || 'Nome indisponível'}
            </Text>
            <Text mt="8px" fontSize="14px" textColor="text.200">
              {data?.phone || 'Telefone indisponível'}
            </Text>
            <Text fontSize="14px" textColor="text.200">
              {data?.email || 'Email indisponível'}
            </Text>
          </>
        )}

        <ModalCloseButton color="black" />

        <ModalFooter pb="0px"></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
